import React from 'react';
import Chip from '../shared/Chip';

/** Which <Chip> a settled decision wears (PRD-1361). `skip` leaves the value unverified. */
const CHIPS = {
  skip: { variant: 'standard', text: 'Can’t verify' },
  correct: { variant: 'success', text: 'Corrected' },
  confirm: { variant: 'success', text: 'Verified' },
};

/**
 * A field the reviewer has already decided on — collapsed to its outcome plus
 * an undo, so a long document reads as a list of what is left.
 */
const DocumentFieldSettled = ({ label, staged, extracted, onUndo }) => {
  const chip = CHIPS[staged.action] || CHIPS.confirm;

  // Figma 1018-2835 gives a settled field the same anatomy as an unsettled one:
  // chip right-aligned in the header row, value in its own grey row with `undo`
  // at its right edge. `skip` has no value, so that row collapses and `undo`
  // moves up beside the chip — which is exactly what the frame draws.
  const hasValue = staged.action !== 'skip';

  return (
    <div className="resui-card resui-card--elevated docreview-field docreview-field--settled">
      <div className="docreview-field-head">
        <h4 className="docreview-field-title">{label}</h4>
        {!hasValue && (
          <button type="button" className="resui-link docreview-undo" onClick={onUndo}>
            undo
          </button>
        )}
        <Chip variant={chip.variant} className="docreview-chip">{chip.text}</Chip>
      </div>
      {hasValue && (
        <div className="docreview-returned">
          <span className="docreview-returned-value">{staged.corrected_value ?? extracted}</span>
          <button type="button" className="resui-link docreview-undo" onClick={onUndo}>
            undo
          </button>
        </div>
      )}
    </div>
  );
};

export default DocumentFieldSettled;
